import {getVal, isnull, isNum, localClear, localGet, localSave} from "../utils/tools";
import aes from "../utils/aes";
import AppSDK from "../api/aapp";

export default {
  skipFromLCMsg: false,
  debug: process.env.ENV !== 'prod',
  app_name: 'WebLiveGirl',
  bundle_id: 'w.livegirl.me',
  channelId: 157,
  reLoginCount: 0,
  clientVersion: '1.2.3',
  appVersion: 0,
  deviceUUID: '',
  deviceName: '',
  session: '',
  appInfo: {},
  user: {},
  globalParams: {},
  linkParams: {},
  privacyUrl: '',
  serviceUrl: '',
  exceptKeys: [
    {
      fullCompare: false,
      key: '_show_vcr_guide'
    }, {
      fullCompare: false,
      key: '_show_chat_hint'
    }, {
      fullCompare: true,
      key: 'app'
    } ,{
      fullCompare: true,
      key: 'ACC'
    } ,{
      fullCompare: true,
      key:'PD'
    }
  ],
  pay: '',
  pay_res_event_success: 'RECHARGE-SUCCESS',
  SHOW_MSG_ACTION_DIALOG: 'SHOW_MSG_ACTION_DIALOG',
  HIDE_MSG_ACTION_DIALOG: 'HIDE_MSG_ACTION_DIALOG',
  SHOW_ALERT_ACTION_DIALOG: 'SHOW_ALERT_ACTION_DIALOG',
  HIDE_ALERT_ACTION_DIALOG: 'HIDE_ALERT_ACTION_DIALOG',
  RE_LOGIN: 'RE_LOGIN',
  EXIT_2_WELCOME: 'EXIT_2_WELCOME',
  SHOW_DEVICE_ERROR: 'SHOW_DEVICE_ERROR',
  LOADING_SHOW: 'LOADING_SHOW',
  LOADING_HIDE: 'LOADING_HIDE',
  KICKED_OFF: 'KICKED_OFF',
  SELF_BLUE_KEY: 'SELF_BLUE_KEY',
  LOGIN_STATUS: 'LOGIN_STATUS',
  CHECK_WEB_AC_PERMISSION: 'CHECK_WEB_AC_PERMISSION',
  NET_CHANGE: "NET_CHANGE",
  INFO_ACC_KEY: 'INFO_ACC_KEY',
  TOAST: 'TOAST',
  LC_NEW_MSG: 'LC_NEW_MSG',
  OPEN_IN_APP: 'OPEN_IN_APP',
  pay_res_event_failed: '',
  application: '',
  s: 'dsP9fm8Dlq3x6cM2RtejmsS6reWxpwuPVFaMs/4wtp9ivZ2a0x/6h852JiRaAsPx',
  agoapp: process.env.ENV !== 'prod' ? 'gh+Q7e8wX3+VmdSqdBVoBXxdAbI60ZgC/k447HJKU4agtu3eiNMvV5qPlspzD0fk' : 'jgnaoUK3W0+ex5EL7W8bLJz6kld4BcL6PkENrLg6JYyvxciH13rL5ozlpoQi/o5n',
  // agoapp: 'jgnaoUK3W0+ex5EL7W8bLJz6kld4BcL6PkENrLg6JYyvxciH13rL5ozlpoQi/o5n',
  agortmk: 'AGORTM',
  im: {
    app: 'TV27LEzG5qJ28ljlk8ssyvJW/jd8y7dw4FnsHjLL5/7ueQnn+BfXGRlnkofjmvYM',
    key: 'l3p+v+J52Yx3i3SVR4xvjAyDqU1THgcbywZJRjoqXco=',
    mk: '6s1BM/L/DljoleShM0DlXgxAh8MHcYBLzzF+QA1oB8w=',
    // server:'https://t668scjf.engine.lncldglobal.com'
    server: '/lc_im'
  },
  of: '',
  agoChatClient: null,
  videoChatRoomConfig: null,
  voiceChatRoomOn: null,
  videoChatRoomOn: null,
  key: {
    app: 'app',
    reLogined: 'reLogined',
    reLoginRes: 'reLoginRes',
    pCfg: 'wdapp-p',//pay config
    user: 'wdapp-user',
    video_chat_config: "VideoChatConfig",
    cfg: "wdapp-cfg",
    ac: 'ACC',
    pd: 'PD',
    moment: 'moment',
    comment: 'comment',
    session: 'wdapp-s',
    TO_RECOMMEND: 'TO_RECOMMEND',
    TAKE_DESC_LIVE: 'TAKE_DESC_LIVE',
    TAKE_DESC_MB: 'TAKE_DESC_MB',
    FROM_LINK_PARAMS: "FROM_LINK_PARAMS",
    SKIP_LIVE: 'skip_live_',
    ACT_URL: "ACT_URL",
    PAYPAL_CFG: 'wdapp-ppcfg',
    STP_CFG: 'wdapp-stpcfg',
    SP_SHOW_BOSS_TIP: 'SP_SHOW_BOSS_TIP',
    SP_SHOW_PRIVATE_TIP: 'SP_SHOW_PRIVATE_TIP',
    CLEAR_CONV_UNREAD: 'clearConvUnRead',
    LAST_CONV_ACC: 'LAST_CONV_ACC',
    RELOAD_ROOM_LIST: "RELOAD_ROOM_LIST",
    RENEW: "RENEW",
    IN_ROOM_ST: "IN_ROOM_ST",
    SEARCH_HISTORY: 'SEARCH_HISTORY',
    GREET_HISTORY: 'GREET_HISTORY',
    VIEWED_MOMENT_HOT: 'VIEWED_MOMENT_HOT',
    GREET_TIPS_HIDE: "_greet_tips_hide",
    MB_BOSS_DEVICE_STATUS: "MB_BOSS_DEVICE_STATUS",
    HIDE_PRE_LOADER: 'HIDE_PRE_LOADER'

  },
  saveAppInfo(appInfo) {
    if (!isnull(appInfo))
      localSave(this.key.app, appInfo)
  },
  async loadAppInfo() {
    if (!isnull(this.appInfo))
      return this.appInfo
    let ss = localGet(this.key.app, '')
    if (!isnull(ss)) {
      this.appInfo = JSON.parse(ss)
      return this.appInfo
    }
    this.appInfo = await AppSDK.loadAppDevice()
    return this.appInfo
  },
  withUserKey(key) {
    return this.getUserDisplay() + '_' + key
  },
  eventLabelList: [],
  sseSource: null,
  pList: [],
  getSession() {
    return localGet(this.key.session, '')
  },
  setEventLabelList(labelList) {
    this.eventLabelList = labelList
  },
  setApplication(instance) {
    this.application = instance
  },
  getApplication() {
    return this.application
  },
  getAppName() {
    if (!isnull(this.appInfo))
      return this.appInfo.appName
    let ss = localGet(this.key.app, '')
    if (!isnull(ss)) {
      this.appInfo = JSON.parse(ss)
      return this.appInfo.appName
    }
    return ''
  },
  setUser(user) {
    this.user = user
  },
  setVoiceChatOn(vcOn) {
    this.saveVideoChatRoomConfig('isVideoChatRoomOn', vcOn)
    this.voiceChatRoomOn = vcOn
  },
  setVideoChatOn(vcOn) {
    this.saveCfg('isVoiceChatRoomOn', vcOn)
    this.videoChatRoomOn = vcOn
  },
  setGlobalCfg(globalCfg) {
    this.globalCfgData = globalCfg
  },
  isVoiceChatOn() {
    if (!this.voiceChatRoomOn)
      this.voiceChatRoomOn = getVal(this.getGlobalConfig(), 'isVoiceChatRoomOn', false);
    return this.voiceChatRoomOn
  },
  isVideoChatOn() {
    if (!this.videoChatRoomOn)
      this.videoChatRoomOn = getVal(this.getVideoChatRoomConfig(), 'isVideoChatRoomOn', false);
    return this.videoChatRoomOn
  },
  isNormal() {
    let user = this.getUser()
    return !isnull(user) && !isnull(user.email)
  },
  clear() {
    this.user = ''
  },
  getUser(refresh = false) {
    if (refresh || isnull(this.user) || Object.getOwnPropertyNames(this.user).length == 0) {
      this.user = JSON.parse(localGet(this.key.user, '{}'))
    }
    return this.user
  },
  getGlobalConfig() {
    if (isnull(this.globalParams) || Object.getOwnPropertyNames(this.globalParams).length == 0) {
      this.globalParams = JSON.parse(localGet(this.key.cfg, '{}'))
    }
    return this.globalParams
  },
  getPrivateChatGiftConfig() {
    if (isnull(this.getGlobalConfig()))
      return {};
    return this.getGlobalConfig().giftConfigs
  },
  getVoiceGiftConfigs() {
    if (isnull(this.getGlobalConfig()))
      return {};

    let vcrGifts = getVal(this.globalParams, 'voiceChatRoomGiftConfigs', {});

    return getVal(vcrGifts, 'giftConfig', [])
  },
  getUserId() {
    if (this.getUser())
      return this.getUser().accountId
    return ''
  },
  getUserDisplay() {
    if (this.getUser())
      return this.getUser().displayAccountId
    return ''
  }, getUserInfo(key) {
    if (this.getUser())
      return this.getUser()[key]
    return ''
  },
  getSSEURL() {
    return this.debug ? "https://test.livegirl.me:9000" : 'https://v.halolive.online:9002'
  },
  getActPushCfg() {
    return this.debug ? {
      conv: '63bb704bbe091569ad0c5559',
      acc: 7121,
      dist: '3487969242'
    } : {
      conv: '5ef848911c4df20008115128',
      acc: 2058,
      dist: '538134'
    }
  },
  setVideoChatRoomConfig(videoChatRoomConfig) {
    this.videoChatRoomConfig = videoChatRoomConfig
  },
  getVideoChatRoomConfig() {
    if (isnull(this.videoChatRoomConfig)) {
      let data = localGet(this.key.video_chat_config, null);
      if (!isnull(data))
        this.videoChatRoomConfig = JSON.parse(data)
    }
    return this.videoChatRoomConfig
  },
  saveVideoChatRoomConfig(key, value) {
    let globalCfg = this.getVideoChatRoomConfig()
    if (isnull(globalCfg))
      globalCfg = {}
    this.videoChatRoomConfig = globalCfg[key] = data
    localSave(this.key.video_chat_config, JSON.stringify(globalCfg))
  },
  setGlobalParams(globalParams) {
    this.globalParams = globalParams
  },
  setSession(session) {
    this.session = session
  },
  clearLinkParams() {
    this.linkParams = null
  },
  setLinkParams(linkParams) {
    this.linkParams = linkParams
    this.linkParams.bundle_id = this.bundle_id
    this.linkParams.af_id = this.getUserId()
    this.udid = this.getUserId()
  },
  getLinkParams() {
    if (isnull(this.linkParams)) {
      this.linkParams = JSON.parse(localGet(this.key.FROM_LINK_PARAMS, '{}'))
      this.setLinkParams(this.linkParams)
    }
    return this.linkParams
  },
  setPay: {},
  agapp: '3dc10e84442948cdace553085e1db1ba',
  hasMultiRoomPrivilege() {
    if (isnull(this.getUser()))
      return false
    return this.getUser() && !isnull(this.getUser().privileges) && this.getUser().privileges.indexOf(4) !== -1
  },
  isVip() {
    if (isnull(this.getUser()))
      return false
    return this.getUser().rechargeAmount > 0
  },
  isSVip() {
    if (isnull(this.getUser()))
      return false
    return this.getUser().isSVip
  },
  setDefaultEventLabel(label) {
    this.globalParams.defaultEventLabel = label
  },
  getDefaultEventLabel() {
    return this.globalParams.defaultEventLabel
  },
  getUniTagUrl() {
    if (!isnull(this.getDefaultEventLabel()))
      return this.getDefaultEventLabel().imageUrl
    return '';
  },
  checkCoinsEnough(coins) {
    if (isnull(this.getUser()))
      return false
    return this.getUser().coins >= coins
  },
  decreaseCoins(coins) {
    let user = this.getUser()
    if (this.checkCoinsEnough(coins))
      user.coins -= coins;
    else
      user.coins = 0
    this.saveUser(user)
  },
  addCoins(coins) {
    let user = this.getUser()
    user.coins += coins;
    this.saveUser(user)
  },
  setCoins(coins) {
    if (parseInt(coins) == 'NAN')
      return
    let user = this.getUser()
    user.coins = coins;
    this.saveUser(user)
  },
  getUserCoins() {
    let coins = this.getUser().coins;
    return !isNaN(parseInt(coins)) ? coins : 0;
  },
  saveUser(user) {
    this.user = user
    localSave(this.key.user, JSON.stringify(user))
  },

  getCfg(key) {
    if (this.getGlobalConfig())
      return this.getGlobalConfig()[key]
    return ''
  },
  saveServerCFG(sCfg) {
    localSave(this.key.cfg, JSON.stringify(sCfg))
  },
  saveCfg(key, data) {
    let globalCfg = this.getGlobalConfig()
    if (isnull(globalCfg))
      globalCfg = {}
    this.globalParams[key] = globalCfg[key] = data
    localSave(this.key.cfg, JSON.stringify(globalCfg))
  },
  getMultiRoomDesc() {
    let vcrDesc = this.getCfg('voiceChatRoomDesc')
    if (isnull(vcrDesc))
      vcrDesc = '没有涉黄描述';
    return vcrDesc
  },
  setPList(pList) {
    if (!isnull(pList)) {
      this.pList = pList
      localSave(this.key.pCfg, JSON.stringify(pList))
    }
  },
  getPList() {
    if (isnull(this.pList)) {
      let origin = localGet(this.key.pCfg)
      if (!isnull(origin))
        this.pList = JSON.parse(origin)
    }
    return this.pList || this.getCfg('payConfigs')
  },
  d() {
    this.s = aes.decrypt(this.s)
  },
  async getAppDeviceId() {
    if (isnull(this.deviceUUID)) {
      this.deviceUUID = await AppSDK.loadAppDevice()
    }
    if (!isnull(this.deviceUUID))
      this.deviceUUID = this.deviceUUID.toUpperCase()
    return this.deviceUUID
  },
  setAppDeviceId(deviceId) {
    if (!isnull(deviceId))
      this.deviceUUID = deviceId
    console.log('afterSetDevice:' + deviceId)
    console.log('afterSetDevice=' + this.deviceUUID)
  },
  setAppDeviceName(deviceName) {
    if (!isnull(deviceName))
      this.deviceName = deviceName
  },
  setAppName(appname) {
    if (!isnull(appname))
      this.app_name = appname
  },
  setAppVersionName(version) {
    if (!isnull(version))
      this.clientVersion = version
  },
  setAppVersion(version) {
    if (isNum(version) && version > -1)
      this.appVersion = version
  },
  setAppChannel(channel) {
    if (isNum(channel) && channel > -1)
      this.channelId = channel
  },
  setPrivacyAddr(privacy) {
    if (!isnull(privacy))
      this.privacyUrl = privacy
  },
  setServiceAddr(service) {
    if (!isnull(service))
      this.serviceUrl = service
  },
  setSecret(secret) {
    if (!isnull(secret))
      this.s = secret
  },


}



// WEBPACK FOOTER //
// ./src/config/global.js